import { render, staticRenderFns } from "./line-row.vue?vue&type=template&id=045a43d2&scoped=true"
import script from "./line-row.vue?vue&type=script&lang=js"
export * from "./line-row.vue?vue&type=script&lang=js"
import style0 from "./line-row.vue?vue&type=style&index=0&id=045a43d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a43d2",
  null
  
)

export default component.exports